import React from "react";
import { Box } from "@mui/material";
import type { DashboardSparklinePoint } from "@services/facilityDashboard";

const W = 80;
const H = 24;

export default function DashboardSparkline({
  points = [],
}: {
  points?: DashboardSparklinePoint[] | null;
}) {
  if (!points?.length) {
    return <Box sx={{ width: W, height: H }} aria-hidden />;
  }
  const values = points.map((p) => p.value);
  const max = Math.max(...values, 1);
  const min = Math.min(...values, 0);
  const range = max - min || 1;
  const step = points.length > 1 ? W / (points.length - 1) : W;
  const coords = points.map((p, i) => {
    const x = i * step;
    const y = H - ((p.value - min) / range) * (H - 2) - 1;
    return `${x},${y}`;
  });
  return (
    <Box component="svg" width={W} height={H} viewBox={`0 0 ${W} ${H}`} aria-hidden>
      <polyline
        fill="none"
        stroke="#4a8fa3"
        strokeWidth="1.5"
        points={coords.join(" ")}
      />
    </Box>
  );
}
